export class ToggleSerializableValue {
  value?: boolean;

  constructor(value?: boolean) {
    this.value = value;
  }
}
